export var ethereumMainnetNetworks = {
    mainnet: {
        name: "Ethereum Mainnet",
        color: "#29b6af",
        chainId: 1,
        rpcUrl: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        blockTime: 15000,
        iconUrl: "./ETH.png",
        blockDelay: 8,
        symbol: "ETH",
        blockExplorerUrl: "https://etherscan.io",
        tokenSymbolList: [
            "USDC",
            "USDT",
            "WETH",
            "BUSD",
            "DODO",
            "LYRA",
            "DOMI",
            "MCB",
            "IMX",
            "oneDODO",
            "OLO",
            "BOBA",
            "FRAX",
            "ONG",
        ],
    },
    bsc: {
        name: "BSC",
        color: "#7057ff",
        chainId: 56,
        rpcUrl: "https://bsc-dataseed.binance.org",
        blockTime: 4000,
        iconUrl: "./bsc.png",
        blockDelay: 8,
        symbol: "BNB",
        blockExplorerUrl: "https://bscscan.com",
        tokenSymbolList: [
            "USDC",
            "USDT",
            "WETH",
            "BUSD",
            "DODO",
            "DOMI",
            "MCB",
            "cUSD",
            "oneDODO",
            "OLO",
            "FRAX",
            "SWAY",
            "ONG",
        ],
    },
    polygon: {
        name: "Polygon (Matic)",
        color: "#3099f2",
        chainId: 137,
        rpcUrl: "https://polygon-rpc.com",
        blockTime: 4000,
        iconUrl: "./polygon.png",
        blockDelay: 80,
        symbol: "MATIC",
        blockExplorerUrl: "https://polygonscan.com",
        tokenSymbolList: ["USDC", "USDT", "WETH", "IMX", "SWAY"],
    },
    arbitrum: {
        name: "Arbitrum",
        color: "#ff4a8d",
        chainId: 42161,
        rpcUrl: "https://arb1.arbitrum.io/rpc",
        blockTime: 4000,
        iconUrl: "./arbitrum.png",
        blockDelay: 8,
        symbol: "ETH",
        blockExplorerUrl: "https://arbiscan.io",
        tokenSymbolList: ["USDC", "USDT", "WETH", "DODO", "MCB", "IMX"],
    },
    Avalanche: {
        name: "Avalanche",
        color: "#3099f2",
        chainId: 43114,
        rpcUrl: "https://api.avax.network/ext/bc/C/rpc",
        blockTime: 5000,
        iconUrl: "./avalanche.png",
        blockDelay: 15,
        symbol: "AVAX",
        blockExplorerUrl: "https://snowtrace.io",
        tokenSymbolList: ["USDC", "USDT", "WETH", "IMX"],
    },
    Optimism: {
        name: "Optimism",
        color: "#3099f2",
        chainId: 10,
        rpcUrl: "https://mainnet.optimism.io",
        blockTime: 5000,
        iconUrl: "./optimism.png",
        blockDelay: 8,
        symbol: "ETH",
        blockExplorerUrl: "https://optimistic.etherscan.io",
        tokenSymbolList: ["USDC", "USDT", "WETH", "LYRA"],
    },
    Fantom: {
        name: "Fantom",
        color: "#3099f2",
        chainId: 250,
        rpcUrl: "https://rpc.ftm.tools",
        blockTime: 5000,
        iconUrl: "./fantom.png",
        blockDelay: 6,
        symbol: "FTM",
        blockExplorerUrl: "https://ftmscan.com",
        tokenSymbolList: ["USDC", "USDT", "WETH"],
    },
    BoBa: {
        name: "Boba Network",
        color: "#3099f2",
        chainId: 288,
        rpcUrl: "https://mainnet.boba.network",
        blockTime: 10000,
        iconUrl: "./boba.png",
        blockDelay: 8,
        symbol: "ETH",
        blockExplorerUrl: "https://blockexplorer.boba.network",
        tokenSymbolList: ["USDC", "OLO", "BOBA"],
    },
};
